import { render } from "./shopCategory.vue?vue&type=template&id=f517c556&scoped=true"
import script from "./shopCategory.vue?vue&type=script&lang=js"
export * from "./shopCategory.vue?vue&type=script&lang=js"

import "./shopCategory.vue?vue&type=style&index=0&id=f517c556&lang=scss&scoped=true"

import exportComponent from "/home/hulk-suman/Music/Insidejob-admin-devlopment-1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f517c556"]])

export default __exports__